import { RxFCompteADocumentType } from "../@schemas/f_comptea.schema";
import { RxFDepotDocumentType } from "../@schemas/f_depot.schema";
import { RxFnParamsDocumentType } from "../@schemas/fn_params.schema";
import { RxPDeviceDocumentType } from "../@schemas/p_device.schema";
import { RxPDeviseDocumentType } from "../@schemas/p_devise.schema";
import { RxPParamsDocumentType } from "../@schemas/p_params.schema";
import { RxPSoucheVenteDocumentType } from "../@schemas/p_souchevente";
import { RxVxParamsDocumentType } from "../@schemas/vx_params.schema";
import { RxFTarifDocument, RxFTarifSelectDocument } from "../@services/m-cashdesk-core-rxdb";

export class CluContextItem {
    PARAMS? : RxPParamsDocumentType | null; 
    FN_PARAMS? : RxFnParamsDocumentType | null; 
    VX_PARAMS? : RxVxParamsDocumentType | null; 
    DEVICE? : RxPDeviceDocumentType | null;
    DEVISE? : RxPDeviseDocumentType | null;
    DEPOT_PRINCIPAL? : RxFDepotDocumentType | null;
    SOUCHEVENTE_PRINCIPALE? : RxPSoucheVenteDocumentType | null;
    AFFAIRE_PRINCIPALE? : RxFCompteADocumentType | null;
    TARIF_ITEMS? : RxFTarifDocument[] | null;
    TARIFSELECT_ITEMS? : RxFTarifSelectDocument[] | null;
}
